import React from 'react';

import { CtaHeroBlockData } from 'api/cms';
import { Box } from 'components/Box';
import { TrackedPrimaryButtonLink } from 'components/Button';
import Flex from 'components/Flex';
import { Hero } from 'components/Hero';
import { RichTextHeadline } from 'components/Text';

type Props = {
  data: CtaHeroBlockData;
  isPageHeader?: boolean;
  blockIndex: number;
  pageUpdated: string;
};

export function CtaHeroBlock({
  data: { buttonText, buttonUrl, text, image, withOverlay },
  isPageHeader,
  blockIndex,
  pageUpdated,
}: Props) {
  return (
    <Hero
      withOverlay={withOverlay}
      heroImage={image}
      data-qa-id="call-to-action-hero"
      minHeight="calc(100vh - 300px)"
    >
      <Box maxWidth="768px" m="0 auto" px="20px">
        <RichTextHeadline
          mt={['48px', '48px', '48px', '80px']}
          mb={['18px', '18px', '18px', '42px']}
          color="white"
          textAlign="center"
          tag={isPageHeader ? 'h1' : undefined}
          $reverseUnderline
        >
          {text}
        </RichTextHeadline>
      </Box>
      <Flex>
        {buttonUrl && buttonText && (
          <TrackedPrimaryButtonLink
            href={buttonUrl}
            eventName="CMS Block"
            eventProperties={{
              block_position: blockIndex,
              block_type: 'Call to Action Hero',
              cta_type: 'Button',
              button_text: buttonText,
              page_updated: pageUpdated,
            }}
          >
            {buttonText}
          </TrackedPrimaryButtonLink>
        )}
      </Flex>
    </Hero>
  );
}
